export default {

    // setDefaultInvoice(state) {
    //     if (state.is_sales) return "invoiceInterfaces/v1.0/platformSaleUpdateDefaultInvoice";//大S
    //     if (state.is_company) return "invoiceInterfaces/v1.0/updateDefaultInvoice";
    //     return "";
    // },
    getScanInfo(state) {
        return state.scanInfo;
    }
}